module.exports = __webpack_public_path__ + "d778475b4fd5f3f206f371d905724a70.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/coh_image_3.png
// module id = 497
// module chunks = 0